import { createSelector } from 'reselect';
import { NOC_MODE_TRENDS, DATASET } from '@utils/constants';
import { payloadSelector as filterPayloadSelector } from '../noc/filtersData/selectors';
import { payloadSelector as trendsPayloadSelector } from '../noc/trendsData/selectors';
import { nocModeSelector } from '../noc/base/selectors';

// TODO: clean this up, export is not available in NOC
// eslint-disable-next-line import/prefer-default-export
export const nocMetaSelector = createSelector(
  filterPayloadSelector,
  trendsPayloadSelector,
  nocModeSelector,
  (filtersPayloadStore, trendsPayloadStore, mode) => {
    const payload = mode === NOC_MODE_TRENDS ? trendsPayloadStore : filtersPayloadStore;
    return {
      dashboardType: 'realtime',
      dataset: DATASET,
      queries: payload.queries,
    };
  },
);
